// ACE uploads can end their lines with LF, CRLF, or a bare CR (what Excel for
// Mac's plain "CSV" save option writes). As in the analyzer's chunk planner,
// the file's FIRST line break decides: a bare-CR file splits on CR, CRLF or
// LF; any other file splits on LF only, as before, so a stray CR inside a
// quoted cell of an LF/CRLF file is not taken as a row break.

/** True when the first line break in `text` is a bare CR. */
export const isBareCrFile = (text: string): boolean => {
  const i = text.search(/[\r\n]/);
  return i >= 0 && text[i] === '\r' && text[i + 1] !== '\n';
};

export const splitLines = (text: string, bareCr: boolean): string[] =>
  text.split(bareCr ? /\r\n|\r|\n/ : /\r?\n/);

/**
 * Number of line breaks in `text`. In a bare-CR file a CRLF counts once, and
 * `afterCr` says the text read just before this slice ended on a CR, so a
 * CRLF split across two FileReader slices is not counted twice.
 */
export const countLineBreaks = (
  text: string,
  bareCr: boolean,
  afterCr = false,
): number => {
  let count = 0;
  for (let i = 0; i < text.length; i++) {
    if (text[i] === '\n') {
      const followsCr = i === 0 ? afterCr : text[i - 1] === '\r';
      if (!bareCr || !followsCr) count++;
    } else if (bareCr && text[i] === '\r') {
      count++;
    }
  }
  return count;
};
